namespace GeniuzPOS.Lookups {
    export namespace VwPsParaService {
        export const baseUrl = 'Lookups/VwPsPara';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwPsParaRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwPsParaRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VwPsPara/Retrieve",
            List = "Lookups/VwPsPara/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwPsParaService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
